import React from "react";
import "./ManageServicesList.css";
import Widgets from "../../../../widgets";
import plusIcon from "../../../../Assets/Icons/PlusIcon.png";
import { useTranslation } from "react-i18next";
import MRList from "./MRList";
import strings from "../../../../utils/strings";

const ManageServicesList = () => {
  const { t } = useTranslation();
  const breadcrumbs = ["nursingCare", "manageService"];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService];
  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="manage-service-heading">{t("services")}</div>
      <div className="manage-service-search-line">
        <Widgets.SearchBox placeholder={"searchByServiceName"} />
        <Widgets.IconButton iconSrc={plusIcon} buttonText="addService" />
      </div>
      <div className="mr-list-box">
        <MRList />
      </div>
    </div>
  );
};

export default ManageServicesList;
